/**
 * `prefers-reduced-motion`, asked the one way every club motion asks it.
 *
 * The stylesheet's own `@media (prefers-reduced-motion: reduce)` block can
 * reach only CSS: it disables the named CSS animations and knows nothing about
 * an OpenLayers view animation (`holeMapAdapter.animationMs`) or a fade timer
 * (`RoundMediaVideoPlayer`), so those ask the same question here.
 *
 * A FUNCTION asked at call time, not a constant read once: the setting can
 * change under a session. Feature-detected, like the viewport query in
 * `HoleMap.tsx`: a platform that cannot be asked has not asked for less. And
 * zero is a jump rather than a refusal — whatever was moving still ends
 * exactly where it was asked to go, it just gets there at once.
 */

/** What a reader asks for when motion makes them ill. */
const REDUCED_MOTION = '(prefers-reduced-motion: reduce)'

/** `ms`, or NOTHING where the reader has asked for less motion. */
export function motionMs(ms: number): number {
  if (typeof window.matchMedia !== 'function') return ms

  return window.matchMedia(REDUCED_MOTION).matches ? 0 : ms
}
